import { AUTO_FILL_UPLINE_ROTATION_SLOTS } from "../../config/autoFillProgramConfig";

export function countFilledAtLevelFromPositions(positions, programDocId, level) {
  return positions.filter(
    (p) =>
      p.programDocId === programDocId &&
      Number(p.level) === Number(level) &&
      p.positionStatus === "filled"
  ).length;
}

/**
 * Pick next roster AFP (by enrollment order) that still accepts a matrix payment
 * at `targetLevel` (3-wide cycle, current level must be ≥ targetLevel).
 */
export function pickNextEligibleMatrixRecipientSync({
  programsByEnrollmentSeq,
  filledCountAtLevel,
  targetLevel,
  excludeProgramIds = [],
}) {
  const level = Number(targetLevel);
  if (level < 1) return null;
  const excluded = new Set(excludeProgramIds.filter(Boolean));

  for (let seq = 1; seq <= AUTO_FILL_UPLINE_ROTATION_SLOTS; seq += 1) {
    const program = programsByEnrollmentSeq.get(seq);
    if (!program) continue;
    if (excluded.has(program.programId)) continue;
    if (program.status && !["active", "on_hold"].includes(program.status)) {
      continue;
    }
    const currentLevel = Number(program.currentLevel) || 1;
    if (currentLevel < level) continue;

    const filled =
      filledCountAtLevel.get(`${program.id || program.docId}:${level}`) ?? 0;
    if (filled >= 3) continue;

    return {
      program,
      programDocId: program.id || program.docId,
      paymentIndex: filled + 1,
      filledAtLevel: filled,
      matrixLevel: level,
    };
  }
  return null;
}

/** Withdrawal spawn: next roster AFP still at L1 needing matrix pay (e.g. chinnigaikwad after mahesh L1 cycle). */
export function pickNextL1WithdrawalSpawnRecipientSync(ctx) {
  return pickNextEligibleMatrixRecipientSync({
    ...ctx,
    targetLevel: 1,
  });
}
